import { render, staticRenderFns } from "./TrainRecordTable.vue?vue&type=template&id=3406b1d0&scoped=true&"
import script from "./TrainRecordTable.vue?vue&type=script&lang=js&"
export * from "./TrainRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./TrainRecordTable.vue?vue&type=style&index=0&id=3406b1d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406b1d0",
  null
  
)

export default component.exports